import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { TarefasService } from 'src/app/tarefas/service/tarefas.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-excluir-tarefas',
  standalone: true,
  templateUrl: './excluir-tarefas.component.html',
  styleUrls: ['./excluir-tarefas.component.scss'],
})
export class ExcluirTarefasComponent implements OnInit {
  @Input() quantidadeTarefas: number = 0;
  @Input() taskID: number | null = null;
  @Input() idObra: number | null = null;
  @Input() selectedTaskIds: number[] = [];
  @Output() fecharDialogo = new EventEmitter<boolean>();
  @Output() tarefaDescartada = new EventEmitter<void>();
  sucessoDescarteTarefa = false;
  @Output() loading = new EventEmitter<boolean>();

  tarefa: any = null;
  exibe: boolean = true;

  constructor(
    private _tarefasService: TarefasService
  ) {}

  ngOnInit() {}

  fecharModal(): void {
    this.fecharDialogo.emit(false);
  }

  deleleTask() {
    this.loading.emit(true);

    let tasksID: string = '';
    if (this.taskID) {
      tasksID = `${this.taskID}`;
    } else if (this.selectedTaskIds && this.selectedTaskIds.length > 0) {
      tasksID = this.selectedTaskIds.join(',');
    } else if (this.tarefa?.raw?.taskID) {
      tasksID = `${this.tarefa.raw.taskID}`;
    }

    const payload = {
      tasksID: tasksID,
    };

    this._tarefasService.deleteTask(payload).subscribe({
      next: () => {
        this.loading.emit(false);
        this.sucessoDescarteTarefa = true;
        Swal.fire({
          title: 'Sucesso!',
          text: 'Tarefa exclu\u00EDda com sucesso!', 

          icon: 'success',
          confirmButtonText: 'OK',
        }).then(() => {
          this.fecharDialogo.emit(true);
        });
      },
      error: () => {
        this.loading.emit(false);
        this.fecharDialogo.emit(false);
      },
    });
  }
}
